/* eslint-disable react/display-name */
import './AllPropositionCommerciales.scss';

import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import PropCommerciale from '../../Components/Docs/PropCommerciale';
import { MaterialTableComponent } from '../../Components/shared/ReusableSmallComponents';
import { StatutsOrdreMision } from '../../data/Interfaces';
// import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useRole from '../../hooks/useRole';
import useUtilities from '../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../Utils/dateFormatter';
import { calculateWorkingDaysBetweenDates, getNomPrenomClearFromPersoData, refPropositionCommerciale, searchLabelInEnumByValue } from '../../Utils/utils';

const AllPropositionCommerciales = () => {
    const { addEuro4Decimal } = useNumberFormatting();
    const role=useRole();
    const { i18n } = useTranslation();
    const PropCommColumns = [
        { field: 'refPC',
            title: i18n.t('Réf.PC'),
            //headerStyle:{width:'84px'},
        },
        {
            field: 'createdAt',
            title: i18n.t('Date d\'émission'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.createdAt),
        },
        {
            field: 'titre',
            title: i18n.t('Intitulé de la mission'),
        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(StatutsOrdreMision,(rowData?.statut))),
        },
        {
            field: 'nomExpert',
            title: i18n.t('Nom d\'expert'),
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'detedebut',
            title: i18n.t('Date de début'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateDebutMission),
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateFinMission',
            title: i18n.t('Date de fin'),
            render:  rowData =>
                formatDateJJMMYYYY(rowData?.dateFinMission),
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dureemission',
            title: i18n.t('Durée de la mission'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureemission,'j');
            }
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dureebdc',
            title: i18n.t('Nb.jours BDC'),
            render: (rowData) => {
                return addEuro4Decimal(rowData?.dureebdc,' j');
            }
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'prixunitaire',
            title: i18n.t('Taux journalier'),
            render:  rowData =>
                addEuro4Decimal(rowData?.prixunitaire)
        //valueGetter: (params: GridValueGetterParams) =>
        //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'chargerecrutement',
            title: i18n.t('Chargé de recrutement'),
        },
        {
            field: 'responsableoper',
            title: i18n.t('Responsable Opérationnel'),
        },
        {
            field: 'responsableachat',
            title: i18n.t('Responsable achat'),
        },
        ...(role==='esn' ?
            [{
                field: 'commercial',
                title: i18n.t('Commercial'),
            }]:[])

    ];
    const [missions, setMissions] = useState();
    const axiosPrivate = useAxiosPrivate();
    const [open, setOpen] = useState(false);
    const [arraymission, setArraymission] = useState([]);
    const [rowselected,setRowSelected]=useState();
    const { setBackdropOpen } = useUtilities();

    const [selectedRow, setSelectedRow] = React.useState(null);

    const handleClickOpen = async () => {
        setOpen(true);
    };

    const handleClose = async () => {

        await getPropositionsCommerciales().then(()=>setOpen(false));
    };

    useEffect(() => {
        getPropositionsCommerciales();
    },[]);

    useEffect(() => {
        if(missions){
            let Array1=[];
            let dureeBdc=0;
            let dureeMission=0;
            console.log('test',missions);
            missions?.reverse()?.forEach(element => {
                dureeBdc=element?.BDCs[0]?.nbJoursBDC ?? calculateWorkingDaysBetweenDates(element?.BDCs[0]?.dateDebutBDC, element?.BDCs[0]?.dateFinBDC);
                dureeMission=calculateWorkingDaysBetweenDates(element?.dateDebutMission, element?.dateFinMission);
                Array1.push({
                    'id': element?._id,
                    'refPC': refPropositionCommerciale(element?.missionId),// * OLD element?.BDCs[0]?.bdcId,
                    'createdAt': element?.BDCs[0]?.createdAt,
                    'titre':element?.titre,
                    'statut':element?.propositionCommerciale?.statut,
                    'motifRejet': element?.propositionCommerciale?.motifRejet,
                    'nomExpert':getNomPrenomClearFromPersoData(element?.expertId?.persoData),
                    'dateDebutMission':element?.dateDebutMission,
                    'companyDataId':element?.companyDataId,
                    'BDCsOP':element?.BDCs,
                    'propositionCommerciale':element?.propositionCommerciale,
                    'localisation':element?.localisation,
                    'xx':element?.companyDataId?.donneeFacturation?.delaiPaiement ?? element?.esnId?.donneeFacturation?.delaiPaiement,
                    'dateFinMission':element?.dateFinMission,
                    'dureemission':dureeMission,
                    'dureebdc':dureeBdc,
                    'expertId':element?.expertId,
                    'prixunitaire':element?.BDCs[0]?.tjClient,
                    'responsableoper':getNomPrenomClearFromPersoData(element?.BDCs[0]?.responsableOperationnelId?.persoData ?? element?.BDCs[0]?.responsableOperationnelEsnId?.persoData),
                    'chargerecrutement':getNomPrenomClearFromPersoData(element?.BDCs[0]?.backOfficeId?.persoData ),
                    'responsableachat':getNomPrenomClearFromPersoData(element?.BDCs[0]?.responsableAchatId?.persoData ?? element?.BDCs[0]?.responsableAchatEsnId?.persoData),
                    'commercial':getNomPrenomClearFromPersoData(element?.BDCs[0]?.collaboratorEsnExpertId?.persoData),
                    ...element
                });
            });

            setArraymission(Array1);
            console.log(Array1,arraymission);
        }
    },[missions]);

    const getPropositionsCommerciales = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get Missions useEffect');
            const response = await axiosPrivate.get('mission/propositionsCommerciales', {
                // signal: controller.signal
            });
            console.log(response.data);
            setMissions(response.data);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };

    return (
        <>
            {role === 'esn'
                ? (
                    <div className='frame5Profile'>
                        {i18n.t('Gestion des missions-HTH')}
                        &gt;
                        <span style={{ color: '#B0B0B0' }}>{i18n.t('Achat')}</span>
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Propositions commerciales')}</span>
                    </div>
                )
                : (
                    <div className='frame5Profile'>
                        {i18n.t('Missions et BDC')}
                        &gt;
                        <span style={{ color: 'rgba(39, 45, 60, 1)' }}>{i18n.t('Propositions commerciales')}</span>
                    </div>
                )
            }

            <div className="HomeFrame">
                <h4 className='titlesociete'>{i18n.t('Propositions commerciales')}</h4>
                <MaterialTableComponent
                    columns={PropCommColumns}
                    data={arraymission}
                    title={i18n.t('Proposition commerciale')}
                    onRowClick={(event, rowData) => {
                        setSelectedRow(rowData?.tableData.id);
                        setRowSelected(rowData);
                        console.log(rowData);
                        console.log(open);
                        handleClickOpen();
                    }}
                    selectedRow={selectedRow}
                />
                {open &&
                <PropCommerciale
                    handleClose={handleClose}
                    mission={rowselected}
                    open={open}
                />}

            </div>
        </>
    );
};

export default AllPropositionCommerciales;
